import {
	HELPER_STATS_LOADING,
	HELPER_STATS_HOURLY_GET,
	HELPER_STATS_HOURLY_ERROR,
	HELPER_STATS_DAILY_GET,
	HELPER_STATS_DAILY_ERROR,
	HELPER_STATS_CURRENT_GET,
	HELPER_STATS_CURRENT_ERROR,
	HELPER_STATS_PERFORMANCE_GET,
	HELPER_STATS_PERFORMANCE_ERROR,
	HELPER_STATS_SUMMARY_GET,
	HELPER_STATS_SUMMARY_ERROR,
	HELPER_STATS_PEAK_GET,
	HELPER_STATS_PEAK_ERROR,
	HELPER_STATS_COMPARISON_GET,
	HELPER_STATS_COMPARISON_ERROR,
	HELPER_STATS_ANOMALIES_GET,
	HELPER_STATS_ANOMALIES_ERROR
} from '../actions/types';

const initialState = {
	helper_stats_loading: false,
	helper_stats_hourly: { data: [] },
	helper_stats_daily: { data: [] },
	helper_stats_current: { data: {} },
	helper_stats_performance: { data: {} },
	helper_stats_summary: { data: {} },
	helpers_stats_peak: { data: {} },
	helpers_stats_comparison: { data: {} },
	helper_stats_anomalies: { data: {} },
	helper_stats_errors: {}
}

export default function helperStatsReducer(state = initialState, action){
	switch(action.type){
		case HELPER_STATS_LOADING:
			return { ...state, helper_stats_loading: action.payload }
		case HELPER_STATS_HOURLY_GET:
			delete state.helper_stats_errors.helper_stats_hourly
			return { ...state, helper_stats_hourly: action.payload }
		case HELPER_STATS_DAILY_GET:
			delete state.helper_stats_errors.helper_stats_daily
			return { ...state, helper_stats_daily: action.payload }
		case HELPER_STATS_CURRENT_GET:
			delete state.helper_stats_errors.helper_stats_current
			return { ...state, helper_stats_current: action.payload }
		case HELPER_STATS_PERFORMANCE_GET:
			delete state.helper_stats_errors.helper_stats_performance
			return { ...state, helper_stats_performance: action.payload }
		case HELPER_STATS_SUMMARY_GET:
			delete state.helper_stats_errors.helper_stats_summary
			return { ...state, helper_stats_summary: action.payload }
		case HELPER_STATS_PEAK_GET:
			delete state.helper_stats_errors.helper_stats_peak
			return { ...state, helpers_stats_peak: action.payload }
		case HELPER_STATS_COMPARISON_GET:
			delete state.helper_stats_errors.helper_stats_comparison
			return { ...state, helpers_stats_comparison: action.payload }
		case HELPER_STATS_ANOMALIES_GET:
			delete state.helper_stats_errors.helper_stats_anomalies
			return { ...state, helper_stats_anomalies: action.payload }
		case HELPER_STATS_HOURLY_ERROR:
		case HELPER_STATS_DAILY_ERROR:
		case HELPER_STATS_CURRENT_ERROR:
		case HELPER_STATS_PERFORMANCE_ERROR:
		case HELPER_STATS_SUMMARY_ERROR:
		case HELPER_STATS_PEAK_ERROR:
		case HELPER_STATS_COMPARISON_ERROR:
		case HELPER_STATS_ANOMALIES_ERROR:
			return {
				...state,
				helper_stats_errors: {
					...state.helper_stats_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
